import React from 'react'
import authorstepthreeStyle from './AuthormobilStepThree.module.css'
import { Link } from 'react-router-dom'

export default function AuthormobilStepThree() {
  return (
    <>
      <div className={authorstepthreeStyle.steppertwo}>
        <div className='row'>
          <div className='col-12'>
            <h3> Terms & Condition </h3>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className={authorstepthreeStyle.mainpdfbox}>
              <div className={authorstepthreeStyle.toppdf}>

              </div>
              <div className={`${authorstepthreeStyle.btmpdf} text-center`}>
                <h6>TermsConditions.pdf</h6>
                <Link>CLICK TO VIEW</Link>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className='mb-3'>
              <div className='form-group text-center'>
                <div className='custom-checkbox d-flex justify-content-center align-items-center'>
                  <input type="checkbox" className="custom-control-input me-2" />
                  <label className={`${authorstepthreeStyle.agreetext} custom-control-label`}> I agree to the above terms and conditions </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
